export default "__VITE_ASSET__Qu7AucGY__"